import { createSlice, current } from '@reduxjs/toolkit';

import { fetchLeaderboardThunk } from './leaderboardThunks';
import { LeaderboardState } from './LeaderboardState';

const leaderboardSlice = createSlice({
  name: 'leaderboard',
  initialState: {
    selectedLeaderboard: null,
    leaderboards: null,
    view: 'current',
  } as LeaderboardState,
  reducers: {
    setSelectedLeaderboard: (state, action) => {
      state.selectedLeaderboard = action.payload;
    },
    handleLeaderboardTimeout: (state, action) => {
      state.selectedLeaderboard = current(state.leaderboards)?.[1] || null;
      state.view = 'previous';

      state.leaderboards = [action.payload.currentLeaderboard, action.payload.nextLeaderboard.leaderboard];
    },
    setLeaderboardView: (state, action) => {
      if (!state.leaderboards) {
        return;
      }

      state.view = action.payload;

      const sortedLeaderboards = [...state.leaderboards].sort(
        (a, b) => new Date(a.endDate).getTime() - new Date(b.endDate).getTime(),
      );

      if (action.payload === 'current') {
        state.selectedLeaderboard = sortedLeaderboards[1];
      } else {
        state.selectedLeaderboard = sortedLeaderboards[0];
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchLeaderboardThunk.fulfilled, (state, action) => {
      state.selectedLeaderboard = action.payload.leaderboard;
      state.leaderboards = [action.payload.previousLeaderboard, action.payload.leaderboard];
    });
  },
});

export const { setLeaderboardView, setSelectedLeaderboard, handleLeaderboardTimeout } = leaderboardSlice.actions;

export default leaderboardSlice.reducer;
